import { classNames } from '@framework/utils';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

type Props = {
  onClick(): void;
  title: string;
  className?: string;
} & (
  | {
      icon?: IconDefinition;
    }
  | {
      iconDOM: ReactNode;
    }
);

export const MenuButton: React.FC<Props> = ({ onClick, title, className, ...props }: Props) => {
  return (
    <button
      onClick={onClick}
      className={classNames('flex w-full cursor-pointer items-center hover:bg-gray-200 focus:outline-none', className)}
    >
      {'icon' in props && props.icon ? (
        <span className="w-10 pl-2">
          <FontAwesomeIcon icon={props.icon} />
        </span>
      ) : 'iconDOM' in props ? (
        <span className="w-10 pl-2">{props.iconDOM}</span>
      ) : (
        <span className="pl-2" />
      )}
      <span className="py-2 pr-2">{title}</span>
    </button>
  );
};
